export const buildRedirectUrl = (
  locale: string = 'en',
  accessDenialRedirectUrl: string,
) => {
  const isRelativePath = accessDenialRedirectUrl?.startsWith('/')
  return isRelativePath
    ? `/${locale}${accessDenialRedirectUrl}`
    : accessDenialRedirectUrl
}
